/**
 * CMP同意ログ送信
 *
 * 通常時はfetchを使用し、ページ離脱時（visibilityState === 'hidden'）は
 * navigator.sendBeacon()にフォールバックする。
 * 送信失敗はリトライせず黙って無視する。
 */

/**
 * 同意ログをサーバーに送信する
 * @param {string} url - 送信先URL
 * @param {Object} data - { consent_id, categories, action }
 */
export function sendConsentLog(url, data) {
  if (!url) return;

  const json = JSON.stringify(data);

  // ページ離脱中はsendBeaconを使用（fetchはキャンセルされる可能性がある）
  if (document.visibilityState === 'hidden' && navigator.sendBeacon) {
    const blob = new Blob([json], { type: 'application/json' });
    navigator.sendBeacon(url, blob);
    return;
  }

  // 通常時はfetchを使用
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: json,
    keepalive: true
  }).catch(() => {}); // エラーは黙って無視
}
